var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7484 40H5.42618C2.44178 40 0 37.556 0 34.5689V9.22381C0 6.23671 2.44178 3.79271 5.42618 3.79271H18.0873C19.0821 3.79271 19.896 4.60738 19.896 5.60308C19.896 6.59878 19.0821 7.41344 18.0873 7.41344H5.42618C4.43138 7.41344 3.61745 8.22811 3.61745 9.22381V34.5689C3.61745 35.5646 4.43138 36.3793 5.42618 36.3793H30.7484C31.7432 36.3793 32.5571 35.5646 32.5571 34.5689V21.8964C32.5571 20.9007 33.371 20.086 34.3658 20.086C35.3606 20.086 36.1745 20.9007 36.1745 21.8964V34.5689C36.1745 37.556 33.7328 40 30.7484 40Z",
    fill: "{themeSvg}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6611 29.1378C12.1908 29.1378 11.7206 28.9568 11.3769 28.6128C10.9247 28.1602 10.7438 27.5085 10.9066 26.893L12.7154 19.6515C12.7877 19.3256 12.9505 19.036 13.1856 18.8187L30.3685 1.60217C32.5028 -0.534057 36.2288 -0.534057 38.345 1.60217C40.5517 3.81082 40.5517 7.39534 38.345 9.58588L21.1621 26.7843C20.927 27.0197 20.6376 27.1826 20.3301 27.255L13.0952 29.0654C12.9505 29.1016 12.8058 29.1197 12.6611 29.1197V29.1378ZM16.0977 21.0093L15.139 24.8291L18.9555 23.8697L35.7947 7.03327C36.5905 6.23671 36.5905 4.95135 35.7947 4.15479C35.035 3.39443 33.6966 3.39443 32.9188 4.15479L16.0977 20.9912V21.0093Z",
    fill: "{themeSvg}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f9874f23ec280fbd5b171d1c5e95b106.svg";
export { ForwardRef as ReactComponent };